import React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import './AppointmentList.css';

const AppointmentList = ({ appointments }) => {
  if (appointments.length === 0) {
    return (
      <div className="appointments-empty">
        <p>No hay citas para hoy</p>
      </div>
    );
  }
  
  const today = new Date();
  const formattedDate = format(today, "dd 'DE' MMMM", { locale: es }).toUpperCase();
  
  return (
    <div className="appointments-list">
      <h3 className="appointments-title">{formattedDate}</h3>
      
      {appointments.map(appointment => (
        <div 
          key={appointment.id} 
          className="appointment-item"
          onClick={() => window.open(appointment.calendarUrl, '_blank')}
        >
          <div className="appointment-time">
            {format(new Date(appointment.date), 'HH:mm', { locale: es })}
          </div>
          <div className="appointment-details">
            <div className="appointment-title">{appointment.title}</div>
            <div className="appointment-client">{appointment.clientName}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AppointmentList;